import { Button } from "@/components/ui/button";
import awijirunFace from "@/assets/images/logo/awijirun_face.jpg";

const EditorIntro = () => {
  return (
    <section className="py-32 px-4 bg-card relative overflow-hidden">
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* 左カラム - 切り取られたプロフィール画像 */}
          <div className="lg:col-span-4 lg:col-start-2">
            <div className="relative mt-12">
              {/* 変なトリミング - 画像の一部だけを見せる */}
              <div className="w-48 h-72 overflow-hidden border border-border ml-0">
                <div className="w-72 h-96 bg-bar-shadow transform translate-x-8 -translate-y-4">
                 <img src={awijirunFace} alt="あうぃじるん かなえ" />
                </div>
              </div>
              {/* 装飾の線 */}
              <div className="absolute -bottom-8 left-24 w-px h-16 bg-border/40" />
            </div>
          </div>

          {/* 右カラム - 自己紹介文（段差をつける） */}
          <div className="lg:col-span-6 space-y-10 mt-0 lg:mt-24">
            {/* 小さなグラスカード - 名前 */}
            <div className="glass-card px-5 py-3 inline-block">
              <h3 className="text-xl md:text-2xl font-medium text-foreground leading-tight tracking-wide">
                あうぃじるん かなえ
              </h3>
            </div>
            
            <div className="space-y-8 text-sm md:text-base text-muted-foreground leading-relaxed font-light">
              <p className="ml-0">
                静かに企画をつくる人です。<br />
                「変わってる。」として、日記や動画、企画などを置いています。
              </p>
            </div>

            {/* SNSボタン - 右寄せ */}
            <div className="flex justify-end pt-8 mr-8 gap-3 flex-wrap">
              <Button
                variant="outline"
                size="sm"
                className="gap-2 border-border hover:bg-primary/10 hover:border-primary transition-colors duration-300"
                asChild
              >
                <a
                  href="https://x.com/awijirun?s=21&t=fSHJ9CenI6va24cOV6FasQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center"
                >
                  <span className="text-sm font-light">X(Twitter)</span>
                </a>
              </Button>
              <Button
                variant="outline"
                size="sm"
                className="gap-2 border-border hover:bg-primary/10 hover:border-primary transition-colors duration-300"
                asChild
              >
                <a
                  href="https://www.youtube.com/@awijirun"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center"
                >
                  <span className="text-sm font-light">YouTube</span>
                </a>
              </Button>
              <Button
                variant="outline"
                size="sm"
                className="gap-2 border-border hover:bg-primary/10 hover:border-primary transition-colors duration-300"
                asChild
              >
                <a
                  href="https://www.tiktok.com/@awijirun"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center"
                >
                  <span className="text-sm font-light">TikTok</span>
                </a>
              </Button>
              <Button
                variant="outline"
                size="sm"
                className="gap-2 border-border hover:bg-primary/10 hover:border-primary transition-colors duration-300"
                asChild
              >
                <a
                  href="https://note.com/awijirun"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center"
                >
                  <span className="text-sm font-light">note</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorIntro;